import { axios } from "../api";

export interface OpenTicket {
  key: string;
  summary: string;
}

/** Open tickets for the current user (scope=me) — used for the chat starter
 *  prompts on the My Tickets page. */
export async function fetchOpenTickets(limit = 3): Promise<OpenTicket[]> {
  const resp = await axios.get("/v6/ticket-portal/requests", {
    params: { status: "open", scope: "me" },
  });
  const rows: any[] = Array.isArray(resp.data) ? resp.data : [];
  return rows
    .filter((r) => r?.key)
    .slice(0, limit)
    .map((r) => ({ key: String(r.key), summary: r?.fields?.summary || "" }));
}

/** Fetch a ticket's summary + description and build a prompt asking the LLM to
 *  answer it from the Aeronet documentation. */
export async function buildTicketPrompt(key: string): Promise<string> {
  const resp = await axios.get(`/v6/ticket-portal/requests/${key}`);
  const fields: Array<{ fieldId: string; value: string }> =
    resp.data?.requestFieldValues || [];
  const summary = fields.find((f) => f.fieldId === "summary")?.value || "";
  const description = fields
    .filter((f) => f.fieldId === "description")
    .map((f) => f.value)
    .join("\n")
    .trim();
  return [
    "A customer support ticket needs answering. Using the Aeronet documentation,",
    "explain how to resolve it and cite the relevant help pages.",
    "",
    `Ticket: ${key}`,
    `Summary: ${summary}`,
    description ? `Description: ${description}` : "",
  ]
    .filter(Boolean)
    .join("\n");
}
